
import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { BaseInjectorService } from 'src/app/base/base-service.injector';
import { AppService } from 'src/app/app.service';
import { ActionManagementService } from "src/app/services/action-management.service";
@Component({
    selector: 'app-filter-action-status',
    templateUrl: './filter-action-status.component.html',
    styleUrls: ['./filter-action-status.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})

export class FilterActionStatusComponent extends BaseInjectorService implements OnInit {
  // @Input() initvalue: any;
  //actiondata = { startDate: this.moment().subtract(15, 'days').format('YYYY-MM-DD'), action_status_open: true, action_status_close: false, selectedvalue: 0, filter_Name: "" };

  actiondata = { startDate: this.moment().subtract(15, 'days').format('YYYY-MM-DD'), action_status_open: true, action_status_close: false, selectedvalue: 0 };
  selectedvalue;
  localappData: any;
  disabled_actionsubmit: boolean = false;

  constructor(private modal: ModalController, private appService: AppService, public action_service: ActionManagementService) {
    super()
  }

  ngOnInit() { }

  ionViewWillEnter() {
    this.selectedvalue = this.action_service.getselected_actionday();
    this.actiondata.action_status_open = this.action_service.getselected_actionaction_open();
    this.actiondata.action_status_close = this.action_service.getselected_actionaction_close();
    this.actiondata.startDate = this.moment().subtract(15, 'days').format('YYYY-MM-DD');
    this.actiondata['no_of_days'] = '15';
    let endDate = this.moment().subtract('15', 'days').format('YYYY-MM-DD');

    this.action_service.setActionFilterData(this.actiondata);

    if (this.actiondata.action_status_open == false && this.actiondata.action_status_close == false) {
      this.disabled_actionsubmit = true;

    } else {
      this.disabled_actionsubmit = false;
    }

  }
  async action_Check(data) {
    if (data.detail.value == 'open') {
      this.actiondata.action_status_open = data.detail.checked;
    } else {
      this.actiondata.action_status_close = data.detail.checked;
    }
    if (this.actiondata.action_status_open == false && this.actiondata.action_status_close == false) {
      this.disabled_actionsubmit = true;
    } else {
      this.disabled_actionsubmit = false;
    }
  }

  async changevalue(d) {
    if (d.detail.value != "") {
      this.action_service.setselected_actionday(d.detail.value);
      this.actiondata.startDate = this.moment().subtract(d.detail.value, 'days').format('YYYY-MM-DD');
      this.actiondata['no_of_days'] = d.detail.value;
      //   this.actiondata.filter_Name = this.initvalue;
    }

  }
  async actionsubmit() {
    this.action_service.setselected_action_open(this.actiondata.action_status_open);
    this.action_service.setselected_action_close(this.actiondata.action_status_close);
    this.action_service.setActionFilterData(this.actiondata);
    this.modal.dismiss(this.actiondata);
  }


  async dismiss() {
    this.modal.dismiss();
  }

}
